var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"38245763477706680fd937b388634e53af7b2ebf"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://957dcee8deb4103167bb14e8a4a9cf2b@o4510829225050112.ingest.us.sentry.io/4510830666907648',
  tracesSampleRate: 0.1,

  beforeSend(event) {
    const message = event.message || event.exception?.values?.[0]?.value || '';

    if (message.includes("Iframe didn't loaded in 20000 ms")) {
      return null;
    }

    return event;
  }
});
